import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetVirtualPosesInput, Result, ResultList, VirtualPosInput, VirtualPosResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class VirtualPosService {

  constructor(private httpClient: HttpClient) { }

  public addVirtualPos(virtualPosInput: VirtualPosInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'VirtualPos/AddVirtualPos', virtualPosInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editVirtualPos(id: number, virtualPosInput: VirtualPosInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'VirtualPos/EditVirtualPos?id=' + id, virtualPosInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteVirtualPos(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'VirtualPos/DeleteVirtualPos?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getVirtualPoses(getVirtualPosesInput: GetVirtualPosesInput): Promise<ResultList<VirtualPosResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'VirtualPos/GetVirtualPoses', getVirtualPosesInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<VirtualPosResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<VirtualPosResult>(), result.error));
  }
}
